import { Accordion } from '@atlas/components';
import { type ComponentProps, type FC, useCallback, useMemo } from 'react';

import Icon from 'components/Icon/Icon';
import Menu, { type MenuItem } from 'components/Menu';
import { usePopups } from 'store';
import { Translation } from 'utils/translations';

import styles from './AccountMenu.module.scss';

const MENU_ITEMS = [
  {
    id: '1',
    label: 'deposit_and_withdraw',
    link: '/account/payment',
    icon: 'money-tick.bold',
  },
  {
    id: '2',
    label: 'transactions',
    link: '/account/transactions',
    icon: 'empty-wallet-time.bold',
  },

  {
    id: '3',
    label: 'account_information',
    link: '/account/profile',
    icon: 'tag-user.bold',
  },
  {
    id: 'logout',
    label: 'logout',
    icon: 'logout.bold',
  },
];

type AccountMenuProps = Pick<
  ComponentProps<typeof Accordion>,
  'onChangeState' | 'appearance'
> & {
  asAccordion?: boolean;
};

const AccountMenu: FC<AccountMenuProps> = ({
  asAccordion = true,
  onChangeState,
  appearance,
}) => {
  const { addPopup } = usePopups();

  const items = useMemo(
    () =>
      MENU_ITEMS.map((item) => ({
        id: item.id,
        label: <Translation message={item.label} />,
        link: item.link,
        icon: item.icon,
      })),
    [],
  );

  const onClickHandler = useCallback(
    (item: MenuItem) => {
      if (item.id === 'logout') {
        addPopup({
          type: 'default',
          contentType: 'logout',
          immediate: true,
          closeByBackdrop: true,
        });
      }
    },
    [addPopup],
  );

  return asAccordion ? (
    <Accordion
      icon={<Icon name="profile-circle" />}
      title={<Translation message="profile" />}
      onChangeState={onChangeState}
      appearance={appearance}
      dataId="account-menu"
    >
      <Menu className={styles.wrapper} items={items} onClick={onClickHandler} />
    </Accordion>
  ) : (
    <Menu
      dataId="account-menu"
      className={styles.wrapper}
      items={items}
      onClick={onClickHandler}
    />
  );
};

export default AccountMenu;
